import * as Yup from "yup";

// eslint-disable-next-line no-useless-escape
export const phoneNumberRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

const ContactFormSchema = Yup.object().shape({
  body: Yup.string().required("Please enter a message"),
  email: Yup.string()
    .ensure()
    .required("Please enter your email address")
    .email("Please enter a valid email address"),
  name: Yup.string()
    .ensure()
    .required("Please enter your name"),
  phone: Yup.string()
    .ensure()
    .required("Please enter your phone number")
    .matches(phoneNumberRegex, "Phone number is not valid")
});

export default ContactFormSchema;
